import _cloneDeep from "lodash/cloneDeep";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.string.at-alternative.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/videoplayer.png';
import _imports_1 from '../../../assets/image/videoplayer.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-dcc63fe4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "document"
};
var _hoisted_2 = {
  class: "document-title"
};
var _hoisted_3 = {
  class: "document-main",
  id: "document"
};
var _hoisted_4 = {
  class: "document-main-left"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "document-main-right"
  }, null, -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "modal"
  }, null, -1);
});
var _hoisted_7 = {
  class: "top-level"
};
var _hoisted_8 = {
  key: 0,
  class: "iconfont icon-xiazai-xian"
};
var _hoisted_9 = {
  key: 1,
  src: _imports_0,
  alt: ""
};
var _hoisted_10 = {
  class: "cover-title"
};
var _hoisted_11 = {
  class: "cover-time"
};
var _hoisted_12 = {
  class: "top-level-right"
};
var _hoisted_13 = {
  class: "document-list"
};
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
  class: "document-list-item-text"
};
var _hoisted_16 = ["onClick"];
var _hoisted_17 = {
  key: 0,
  src: _imports_1,
  alt: ""
};
var _hoisted_18 = {
  key: 1,
  class: "iconfont icon-xiazai-xian"
};
import { $convertUTCDateToLocalDate, $getCdnUrl } from '@/assets/common/common';
import downloadFile from '@/utils/download';
import { useMatomo } from '@shining3d/matomo';
import { useRouter } from 'vue-router';
import WordHighlighter from 'vue-word-highlighter';
import { useStore } from 'vuex';
import { useLang } from '../../../hooks/lang';
export default {
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    name: {
      type: String,
      default: ''
    },
    query: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useLang = useLang(),
      $t = _useLang.$t;
    var matomo = useMatomo();

    // 根据视频与文档的数量谁多就以谁为主显示,一样多就显示视频
    var mainType = computed(function () {
      var videoNum = 0;
      var docNum = 0;
      props.list.forEach(function (item) {
        if (item.docType === 'doc' || item.docType === 'other') {
          docNum = docNum + 1;
        } else if (item.docType === 'video') {
          videoNum = videoNum + 1;
        }
      });
      return videoNum >= docNum ? 'video' : 'doc';
    });
    var coverSrc = computed(function () {
      var cover = props.list.find(function (item) {
        return item.docType === mainType.value;
      });
      if (cover) {
        return $getCdnUrl({
          bucket: cover === null || cover === void 0 ? void 0 : cover.pageBucket,
          dfsID: cover === null || cover === void 0 ? void 0 : cover.pageDfsId
        });
      } else {
        return {};
      }
    });
    var showList = computed(function () {
      var firstMainTypeIndex = props.list.findIndex(function (item) {
        return item.docType === mainType.value;
      });
      var arr = _cloneDeep(props.list);
      arr.splice(firstMainTypeIndex, 1);
      return [props.list[firstMainTypeIndex], arr];
    });
    var handleCoverImg = function handleCoverImg(item) {
      return $getCdnUrl({
        bucket: item.pageBucket,
        dfsID: item.pageDfsId
      });
    };
    var handleLeftClick = function handleLeftClick(item) {
      if (item.docType === 'doc') {
        preview(item);
      } else if (item.docType === 'video') {
        toVideo(item);
      }
      matomo.log('click', '支持与下载|主题资料|浏览', '用户在线浏览主题资料');
    };
    var handleRightClick = function handleRightClick(item) {
      if (item.docType === 'video') {
        toVideo(item);
      } else {
        var url = $getCdnUrl(item);
        downloadFile(url, item.name);
      }
      matomo.log('click', '支持与下载|主题资料|浏览', '用户在线浏览主题资料');
    };
    var preview = function preview(item) {
      if (item.docType === 'other') {
        return;
      }
      window.open($getCdnUrl(item) + '?response-content-type=application/pdf', '文件预览');
    };
    var router = useRouter();
    var toVideo = function toVideo(item) {
      router.push({
        path: '/video',
        query: {
          bucket: item.bucket,
          dfsID: item.dfsID,
          comments: item.comments,
          docName: item.docName,
          createOn: item.createOn
        }
      });
    };
    var store = useStore();
    onMounted(function () {
      store.commit('setComponentNum', 1);
    });
    return function (_ctx, _cache) {
      var _unref$2;
      var _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.name || _unref($t)("productIntroduce")), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_image, {
        class: "cover",
        src: _unref(coverSrc),
        fit: "cover"
      }, null, 8, ["src"])]), _hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "top-level-left",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return handleRightClick(_unref(showList)[0]);
        })
      }, [_unref(mainType) === 'doc' ? (_openBlock(), _createElementBlock("i", _hoisted_8)) : (_openBlock(), _createElementBlock("img", _hoisted_9))]), _createElementVNode("span", _hoisted_10, [_createVNode(_unref(WordHighlighter), {
        query: __props.query,
        "highlight-style": "color:#FFFFFF;background: #5587FF;"
      }, {
        default: _withCtx(function () {
          var _unref$;
          return [_createTextVNode(_toDisplayString(((_unref$ = _unref(showList)[0]) === null || _unref$ === void 0 ? void 0 : _unref$.docName) || ""), 1)];
        }),
        _: 1
      }, 8, ["query"])]), _createElementVNode("span", _hoisted_11, _toDisplayString(_unref($convertUTCDateToLocalDate)((_unref$2 = _unref(showList)[0]) === null || _unref$2 === void 0 ? void 0 : _unref$2.createOn, "YYYY-MM-DD")), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showList)[1], function (i) {
        return _openBlock(), _createElementBlock("div", {
          class: "document-list-item",
          key: i
        }, [_createElementVNode("div", {
          class: "document-list-item-left",
          onClick: function onClick($event) {
            return handleLeftClick(i);
          }
        }, [_createVNode(_component_el_image, {
          class: "img",
          src: handleCoverImg(i),
          fit: "cover"
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_15, [_createVNode(_unref(WordHighlighter), {
          query: __props.query,
          "highlight-style": "color:#FFFFFF;background: #5587FF;"
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(i.docName), 1)];
          }),
          _: 2
        }, 1032, ["query"]), _createVNode(_unref(WordHighlighter), {
          query: __props.query,
          "highlight-style": "color:#FFFFFF;background: #5587FF;"
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(i === null || i === void 0 ? void 0 : i.name.split(".").at(-1)) + " | " + _toDisplayString(_unref($convertUTCDateToLocalDate)(i.createOn, "YYYY-MM-DD")), 1)];
          }),
          _: 2
        }, 1032, ["query"])])], 8, _hoisted_14), _createElementVNode("div", {
          class: "document-list-item-right",
          onClick: function onClick($event) {
            return handleRightClick(i);
          }
        }, [i.docType === 'video' ? (_openBlock(), _createElementBlock("img", _hoisted_17)) : (_openBlock(), _createElementBlock("i", _hoisted_18))], 8, _hoisted_16)]);
      }), 128))])])])])]);
    };
  }
};